import { Routes } from '@angular/router';
import { AuthGuard } from '../../shared/guards/auth.guard';
import { ChangelogComponent } from './changelog.component';

const changelogRoutes: Routes = [
    {
        path: '',
        component: ChangelogComponent,
        canActivate: [AuthGuard],
    },
];

export default changelogRoutes;
